import { render, staticRenderFns } from "./AccountSetupFlow.vue?vue&type=template&id=6ccfd386&scoped=true&"
import script from "./AccountSetupFlow.vue?vue&type=script&lang=js&"
export * from "./AccountSetupFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccfd386",
  null
  
)

export default component.exports